// Canonical wire values shared with the backend handoff. Labels and colours
// remain presentation concerns; API requests and responses use these values.
export const ULTIMATE_AGENT_ENUMS = {
  Persona: ["LANDLORD", "AGENT", "TENANT"],
  LandlordType: ["INDIVIDUAL", "COMPANY"],
  RegistrationSource: ["existing-customer", "self-registration", "tenant-invitation"],
  InvitationStatus: ["VALID", "USED", "EXPIRED", "REVOKED"],
  MobileVerificationPurpose: ["ULTIMATE_AGENT_REGISTRATION"],
  YesNo: ["YES", "NO"],
  TeamRole: ["OWNER", "MANAGER", "AGENT", "VIEWER"],
  TeamMemberStatus: ["ACTIVE", "PENDING", "DISABLED", "REMOVED"],

  ApplicationStatus: [
    "DRAFT", "INVITED", "IN_PROGRESS", "VERIFICATION_REVIEW",
    "READY_FOR_DECISION", "APPROVED", "REJECTED", "WITHDRAWN", "EXPIRED",
  ],
  ApplicationRecommendation: ["APPROVE", "REJECT"],
  InviteChannel: ["EMAIL", "SMS", "EMAIL_AND_SMS"],
  DashboardTrend: ["success", "warning", "danger", "neutral"],
  DashboardIconKey: [
    "HOME", "APPLICATION", "COLLECTION", "MANDATE", "CLOCK",
    "WARNING", "REPORT", "PROPERTY", "SUCCESS",
  ],

  VerificationCheckType: [
    "NIN", "BVN", "GOVT_ID", "LIVENESS", "ADDRESS",
    "PREVIOUS_LANDLORD", "LANDLORD_REF", "RENTAL_HISTORY", "CRIMINAL",
    "CREDIT", "SALARY", "BANK_STATEMENT", "SOURCE_OF_FUNDS", "EMPLOYMENT",
    "EMPLOYMENT_REFERENCE", "GUARANTOR", "CHARACTER_REF",
  ],
  VerificationCheckState: [
    "NOT_REQUESTED", "REQUESTED", "IN_PROGRESS", "SUBMITTED", "PASSED",
    "FAILED", "MANUALLY_VERIFIED", "WAIVED", "INCONCLUSIVE", "EXPIRED",
  ],
  VerificationReviewDecision: ["PASS", "FAIL", "INCONCLUSIVE"],
  VerificationSection: [
    "RESIDENCE", "AFFORDABILITY", "EMPLOYMENT_DETAILS", "INCOME",
    "REFERENCE", "LANDLORD_REFERENCE", "SOURCE_OF_FUNDS",
    "GUARANTOR_DETAILS", "CHARACTER_REFERENCE", "EVIDENCE",
  ],
  VerificationMethod: [
    "BANK_CONNECTION", "DOCUMENT_UPLOAD", "FIELD_VERIFICATION",
    "LANDLORD_CONFIRMATION", "EMPLOYER_REFERENCE", "REFERENCE_CONTACT",
  ],
  VerificationExecution: ["AUTOMATED", "PROVIDER_SESSION", "PARTICIPANT"],
  OccupancyType: ["RENT", "OWN", "FAMILY", "EMPLOYER_PROVIDED"],
  RentResponsibility: ["SELF_ALL_OR_PART", "PAID_IN_ADVANCE", "THIRD_PARTY", "GUARANTOR"],
  IncomeSource: [
    "PERMANENT_EMPLOYMENT", "CONTRACT_EMPLOYMENT", "SELF_EMPLOYED",
    "SAVINGS_INVESTMENTS", "PENSION", "BENEFITS", "STUDENT_SUPPORT", "OTHER",
  ],

  UnitStatus: ["VACANT", "OCCUPIED", "NOTICE", "MAINTENANCE"],
  PropertyType: [
    "Apartment Block", "Serviced Apartment", "Detached House",
    "Studio / Self-contain", "Terrace", "Bungalow", "Luxury Apartment",
    "Commercial/Residential",
  ],
  VacateReason: ["TENANCY_ENDED", "EARLY_TERMINATION", "EVICTION", "TRANSFER"],
  CheckoutCondition: ["INSPECTION_REQUIRED", "GOOD", "DAMAGE_RECORDED"],
  PropertyDocumentCategory: ["LEGAL", "IDENTITY", "FINANCIAL", "INSPECTION", "OTHER"],

  ContractStatus: [
    "DRAFT", "SENT", "TENANT_SIGNED", "ACTIVE", "RENEWAL_DUE",
    "EXPIRED", "TERMINATED",
  ],
  ContractTermsQueryStatus: ["OPEN", "RESPONDED", "RESOLVED"],
  ContractTermsTopic: [
    "Rent and payment schedule", "Security deposit", "Tenancy dates or renewal",
    "Notice and termination", "Repairs and responsibilities",
    "Special conditions", "Other",
  ],
  SignatureType: ["ELECTRONIC"],

  TenancyStatus: ["PENDING_CONTRACT", "ACTIVE", "ENDING_SOON", "OVERDUE", "PAST", "TERMINATED"],
  RentFrequency: ["MONTHLY", "QUARTERLY", "ANNUALLY"],
  IncomePaymentFrequency: ["WEEKLY", "FORTNIGHTLY", "MONTHLY", "QUARTERLY", "IRREGULAR"],
  TenancyPaymentFrequency: ["Monthly", "Quarterly", "Semi-annually", "Annually"],
  PaymentStatus: ["PENDING", "PENDING_RECONCILIATION", "PAID", "FAILED", "OVERDUE", "UPCOMING", "REVERSED"],
  PaymentMethod: ["DIRECT_DEBIT", "STANDING_ORDER", "BANK_TRANSFER", "CASH", "OFFSET"],
  MandateStatus: ["ACTIVE", "PENDING", "INACTIVE", "FAILED", "CANCELLED"],
  ContactPreference: ["IN_APP", "EMAIL", "CALLBACK"],

  MaintenanceStatus: ["OPEN", "TRIAGED", "IN_PROGRESS", "AWAITING_TENANT", "RESOLVED", "CLOSED"],
  MaintenanceUrgency: ["NORMAL", "URGENT", "EMERGENCY"],
  MaintenanceCategory: ["Repairs", "Plumbing", "Electrical", "Security", "Other"],
  MaintenanceContactChannel: ["IN_APP", "EMAIL", "SMS"],

  SecurityDepositStatus: [
    "HELD", "PROTECTED", "RELEASE_PENDING",
    "DISPUTED", "PARTIAL_RELEASE", "RELEASED",
  ],
  DepositClaimType: ["DEDUCTION_DISPUTE", "NON_RELEASE", "AMOUNT_MISMATCH", "DAMAGE_CLAIM", "OTHER"],
  DepositReleaseMethod: ["BANK_TRANSFER", "CASH", "OFFSET"],
  DepositClaimStatus: ["OPEN", "RESOLVED", "CANCELLED"],
  DepositClaimResolution: ["RELEASE_PENDING", "DISPUTED"],

  CollectionStatus: ["INITIATED", "PROCESSING", "SUCCESSFUL", "FAILED", "PARTIALLY_COLLECTED", "REVERSED"],
  ReconciliationStatus: ["UNMATCHED", "NEEDS_REVIEW", "MATCHED", "RESOLVED"],
  ReconciliationAction: ["MATCH", "RESOLVE", "IGNORE"],
  ReportFormat: ["CSV", "PDF", "XLSX"],

  RealtimeNotificationType: ["ultimate_agent"],
  RealtimeAction: [
    "profile_updated", "application_updated", "verification_updated",
    "property_updated", "contract_updated", "tenancy_updated",
    "maintenance_updated", "security_deposit_updated", "collection_updated",
    "team_updated", "report_ready",
  ],
  RealtimeEntityType: [
    "PROFILE", "APPLICATION", "VERIFICATION", "PROPERTY", "CONTRACT",
    "TENANCY", "MAINTENANCE", "SECURITY_DEPOSIT", "COLLECTION", "TEAM", "REPORT",
  ],
};

export const ULTIMATE_AGENT_ENUM_NAMES = Object.keys(ULTIMATE_AGENT_ENUMS);
